export const SurgicalSiteInfectionOptions = [
    { name: 'SpinalProcedure', description: 'Spinal Procedure' },
    { name: 'ShoulderProcedure', description: 'Shoulder Procedure' },
    { name: 'ElbowProcedure', description: 'Elbow Procedure' },
    { name: 'LaparoscopicGastricBypass', description: 'Laparoscopic Gastric Bypass' },
    { name: 'CardiacImplantableElectronicDevice', description: 'Cardiac Implantable Electronic Device' },
];
